import React, { useState } from 'react';
import { musicAPI } from '../services/api';
import { normalizeYouTubeUrl } from '../helpers/youtube';

const YouTubeUpload = ({ onSubmit, loading }) => {
    const [url, setUrl] = useState('');
    const [playlist, setPlaylist] = useState([]);
    const [song_play_time, setSongPlayTime] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    // const 

    const fetchPlaylist = async (link) => {
        try {
            setError(null);
            setPlaylist([]);
            const response = await musicAPI.fetch_youtube_playlist(encodeURIComponent(link));
            setPlaylist(response);
        } catch (err) {
            // setError(`Failed to fetch playlist: ${err.response?.data?.detail || err.message}`);
            fetchMetadata(link)
        }
    };

    const fetchMetadata = async (link) => {
        try {
            setError(null);
            setPlaylist([]);


            const response = await fetch(
                `https://www.youtube.com/oembed?url=${encodeURIComponent(normalizeYouTubeUrl(link))}&format=json`
            );
            if (!response.ok) throw new Error(`Failed to fetch metadata: ${response.statusText}`);
            const data = await response.json();
            setPlaylist([
                {
                    url: normalizeYouTubeUrl(link),
                    title: data.title || 'Unknown title',
                    artist: data.author_name || 'Unknown artist',
                    thumbnail: data.thumbnail_url || '',
                },
            ]);
        } catch (err) {
            setError(err.message);
        }


    };

    const handleUrlChange = (e) => {
        const newUrl = e.target.value;
        setUrl(newUrl);


        if (newUrl.includes('youtube.com') || newUrl.includes('youtu.be')) {
            if (newUrl.includes('list=')) {
                fetchPlaylist(newUrl);
            } else {
                fetchMetadata(newUrl);
            }
        }


    };

    const updateSong = (index, updates) => {
        setPlaylist((prev) =>
            prev.map((song, i) => (i === index ? { ...song, ...updates } : song))
        );
    };

    const removeSong = (index) => {
        setPlaylist((prev) => prev.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!playlist.length || !song_play_time) return;

        try {
            for (const song of playlist) {
                try{
                    await musicAPI.save_youtube_link({
                        url: song.url,
                        title: song.title,
                        artist: song.artist,
                        song_play_time,
                    });
                }catch (err) {
                    setError(`Skipping ${song.title}`)
                }
            }
            setSuccess('All songs saved successfully.');
            setUrl('');
            setPlaylist([]);
            setSongPlayTime('');
        } catch (err) {
            setError(`Failed: ${err.response?.data?.detail || err.message}`);
        }


    };

    return (<form className="youtube-upload" onSubmit={handleSubmit}> <h2>Add YouTube Link or Playlist</h2> <input
        type="text"
        placeholder="Paste YouTube link or playlist URL..."
        value={url}
        onChange={handleUrlChange}
        disabled={loading}
        className="youtube-input"
    />


        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        {
                Array.isArray(playlist) && playlist.length > 0 && (

                <>
                    <label>
                        Play Time
                        <select
                            required
                            value={song_play_time}
                            onChange={(e) => setSongPlayTime(e.target.value)}
                        >
                            <option value="">--Select Option--</option>
                            <option value="morning">Morning</option>
                            <option value="evening">Evening</option>
                            <option value="night">Night</option>
                            <option value="day">Day Time</option>
                        </select>
                    </label>

                    <div className="playlist-preview">
                        {playlist.map((song, index) => (
                            <div key={index} className="song-item">
                                <img src={song.thumbnail} alt={song.title} className="thumbnail" />
                                <div className="song-fields">
                                    <input
                                        type="text"
                                        value={song.title}
                                        onChange={(e) => updateSong(index, { title: e.target.value })}
                                    />
                                    <input
                                        type="text"
                                        value={song.artist}
                                        onChange={(e) => updateSong(index, { artist: e.target.value })}
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="remove-btn"
                                    onClick={() => removeSong(index)}
                                >
                                    Remove
                                </button>
                            </div>
                        ))}
                    </div>

                    <button type="submit" disabled={loading || !song_play_time}>
                        {loading ? 'Saving...' : 'Save All'}
                    </button>
                </>
            )
        }
    </form >

    );
};

export default YouTubeUpload;
